
import React from "react";

import { summaryInterface } from "../../../../typings/interfaces";

import { IndexGallery } from "../../../../components";
import { HrCountryId, ModuleNameHr } from "../../../../models";

import SummaryInfo from "./SummaryInfo";
import SummaryPrice from "./SummaryPrice";
import styles from "./summarySection.scss";
import AdLocationMap from "../../AdLocationMap/AdLocationMap";
import { SHOULD_SHOW_OPEN_LAYER_MAPS } from "../../../../constants";

export interface SummarySectionInterface {
  adSummary: summaryInterface;
  disabled: boolean;
  showViewedCount: boolean;
  category?: string;
  module?: string;
  specialAttributes?: any[];
}

const SummarySection = (props: SummarySectionInterface) => {
  const {
    adSummary,
    disabled,
    showViewedCount,
    category,
    module,
    specialAttributes
  } = props;

  // Location names come with the ad summary (countryName, countyName, cityName, settlementName)
  const constructAddress = () => {
    if (!adSummary) {
      return null;
    }

    if (adSummary.countryId && adSummary.countryId !== HrCountryId) {
      return { settlementName: adSummary.countryName || "", address: "" };
    }

    const address = [adSummary.cityName, adSummary.countyName].filter(Boolean).join(", ");

    if (!address) return { settlementName: adSummary.countryName || "", address };

    return { address, settlementName: adSummary.settlementName || "" };
  };

  const address = constructAddress();

  return (
    <section className={styles.wrapper}>
      <IndexGallery
        images={adSummary.images}
        floorPlans={adSummary.floorPlans}
        videoUrl={adSummary.videoUrl}
        priceReductionPercentage={adSummary.priceReductionPercentage}
        featuredProperty={adSummary.featuredProperty}
        category={category}
        specialAttributes={specialAttributes}
        adSummary={adSummary}
      />
      <div
        className={`${styles.summarySection} ${disabled ? styles.disabled : ""
          }`}
      >
        <SummaryInfo adSummary={adSummary} showViewedCount={showViewedCount} />
        <SummaryPrice adSummary={adSummary} />

        {adSummary && adSummary.locationScope && adSummary.locationScope !== 1 ? (
          // V2OGLASI-2648: Jobs/Services wider-area ads — see web
          // SellerSection for the full note.
          <React.Fragment>
            <div><b>
              {module === ModuleNameHr.jobs
                ? "Područje rada"
                : module === ModuleNameHr.services
                  ? "Područje pružanja usluge"
                  : "Lokacija"}
            </b></div>
            <div>{adSummary.locationName}</div>
          </React.Fragment>
        ) : (address && (address.address || address.settlementName)) ? (
          <React.Fragment>
            <div><b>{"Lokacija"}</b></div>
            <div>
              {address.settlementName ? address.settlementName : ""}
              {(address.settlementName && address.address) && ", "}
              {address.address ? address.address : ""}
            </div>
            {SHOULD_SHOW_OPEN_LAYER_MAPS && <AdLocationMap adSummary={adSummary} />}
          </React.Fragment>
        ) : null}
      </div>
    </section>
  );
};

SummarySection.defaultProps = {
  adSummary: null,
  disabled: false,
  showViewedCount: false
};

export default SummarySection;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/SummarySection/index.tsx